import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch
  //  Redirect
} from "react-router-dom";
import "./App.css";
import Welcome from "./pages/Login/Welcome";
import About from "./pages/Settings/About";
import Settings from "./pages/Settings/Settings";
import History from "./pages/History/History";
import FAQ from "./pages/Settings/FAQ";

import "bootstrap/dist/css/bootstrap.min.css";

const apiUrl = process.env.REACT_APP_API_ENDPOINT;

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: null
    };
  }

  PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={props => (
        <Component
          {...props}
          apiUrl={apiUrl}
          token={localStorage.getItem("token")}
        />
      )}
    />
  );

  render() {
    const NoAuthRoute = ({ component: Component, ...rest }) => (
      <Route
        {...rest}
        render={props => <Component {...props} apiUrl={apiUrl} />}
      />
    );

    const authContainer = () => {
      return (
        <div className="main-app">
          <Route exact path="/" component={Welcome} />
          <NoAuthRoute
            exact
            path="/home"
            component={Welcome}
          />
          <this.PrivateRoute exact path="/settings" component={Settings} />
          <this.PrivateRoute exact path="/about" component={About} />
          <this.PrivateRoute exact path="/history" component={History} />
          <this.PrivateRoute exact path="/faq" component={FAQ} />
        </div>
      );
    };

    return (
      <Router>
        <Switch>
          <Route component={authContainer} />
        </Switch>
      </Router>
    );
  }
}
